/* istanbul ignore file */
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeDrawer, openDrawer } from 'state/slices/notificationsSlice';
import { RootState } from 'state/store';

export function useNotificationDrawer() {
  const dispatch = useDispatch();
  const isOpen = useSelector((state: RootState) => state.notifications.drawerOpen);

  const onOpen = useCallback(() => dispatch(openDrawer()), [dispatch]);
  const onClose = useCallback(() => dispatch(closeDrawer()), [dispatch]);

  return { isOpen, onOpen, onClose };
}
